<template>
  <div id="address-phone">
    <div class="left">
      <div class="phone-number">服务电话：{{ phoneNumber }}</div>
      <div class="address">
        <h3 class="address-title">公司地址：</h3>
        <ul class="address-list">
          <li class="item" v-for="(item, index) of address" :key="index">
            {{ item }}
          </li>
        </ul>
      </div>
    </div>
    <div class="right">
      <div class="qrcode">
        <img src="../../../../assets/images/lanshiqrcode.png" alt="" />
        <h3>蓝十医疗公众号</h3>
      </div>
      <div class="qrcode">
        <img src="../../../../assets/images/chunhuaqrcode.png" alt="" />
        <h3>春华健康公众号</h3>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AddressPhone",
  components: {},
  data() {
    return {
      phoneNumber: "400-808-9629",
      address: [
        "北京市朝阳区东三环中路7号北京财富中心写字楼A座908A",
        "合肥市高新区创新大厦2688号中信大厦11层",
        "上海市虹口区东大名路501号白玉兰广场23层",
        "深圳市南山区南山大道粤海路肾脏动漫园3-4栋5F"
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
#address-phone {
  margin-top: 150px;
  color: #ffffff;
  display: flex;
  /*align-items: center;*/
  justify-content: center;
  .left {
    .phone-number {
      font-size: 20px;
    }
    .address {
      line-height: 30px;
      margin-top: 10px;
      .address-title {
        font-size: 20px;
      }
      .address-list {
        text-indent: 6em;
      }
    }
  }
  .right {
    margin-left: 32px;
    display: flex;
    .qrcode {
      margin-right: 34px;
      img {
        width: 157px;
        height: 157px;
      }
      h3 {
        font-size: 16px;
        text-align: center;
        margin-top: 16px;
      }
    }
  }
}
</style>
